import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';

/**
 * Returns a callback you can wrap around something that will not run on the first call.
 * Use this when the server rendered data already applied, so front-end logic can be skipped the first time. E.g:
 * const skipFirst = useSkipFirstCall();
 * useEffect(
 *     () => skipFirst(() => doThing()),
 *     [query],
 * );
 */
export const useSkipFirstCall = () => {
  const $ = _c(1);
  const called = useRef(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = callback => {
      if (called.current === false) {
        called.current = true;
        return;
      }
      callback();
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};